var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("validation-observer", [
        _c(
          "div",
          { staticClass: "row" },
          [
            _vm._l(_vm.input, function(answerType, index) {
              return _c(
                "div",
                { key: answerType.id, staticClass: "mt-4 col-md-3" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start"
                    },
                    [
                      _c("input", {
                        staticClass: "custom-radio",
                        attrs: { disabled: true, type: "radio" }
                      }),
                      _c(
                        "div",
                        { staticClass: "ml-3 w-100" },
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-input", {
                                        attrs: {
                                          "custom-error-msg":
                                            "El campo es requerido.",
                                          error: errors[0]
                                        },
                                        model: {
                                          value: answerType.name,
                                          callback: function($$v) {
                                            _vm.$set(answerType, "name", $$v)
                                          },
                                          expression: "answerType.name"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      ),
                      index > 1
                        ? _c("div", { staticClass: "ml-3" }, [
                            _c("i", {
                              staticClass: "far fa-times-circle text-danger",
                              on: {
                                click: function($event) {
                                  return _vm.triggerConfirmation(index)
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ]
                  )
                ]
              )
            }),
            _vm.canAddMore
              ? _c("div", { staticClass: "mt-4 col-md-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start mt-2"
                    },
                    [
                      _c("input", {
                        staticClass: "custom-radio",
                        attrs: { disabled: true, type: "radio" }
                      }),
                      _c("div", { staticClass: "ml-3 w-100" }, [
                        _c(
                          "u",
                          {
                            staticClass: "add-button",
                            on: { click: _vm.addAnswerType }
                          },
                          [_vm._v(" Agregar una opción ")]
                        )
                      ])
                    ]
                  )
                ])
              : _vm._e()
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }